import axios from "axios";

import { BASE_PATH as RIC_AUTH_PATH } from "../../../../../gen/authapi/base";
import { BASE_PATH as RSS_PATH } from "../../../../../gen/rssapi/base";
import { BASE_PATH as RIC_PATH } from "../../../../../gen/ricapi/base";

import commons from "@/common/store/modules/commons";
import loginInfo from "@/general/store/modules/loginInfo";
import LocalStorage from "@/general/utils/storage";

// REQUEST Interceptor
axios.interceptors.request.use(
  function(config) {
    const RIC_AUTH_KEY = "FO1CTLVe.OvjzddyzTOGy5zNBnOQalqGCCtGLg8lZ";
    const RSS_KEY = "nZnhLXdj.xiqPJCE9OStyAwLeVIoLxUpTE7stmK2r";
    const RIC_KEY = "GL9LVTNl.4zCo5g0C8jmlvw17Bp0Kj6icvSTOSNDy";

    let key;
    if (config.url.startsWith(RIC_PATH)) {
      key = RIC_KEY;
    } else if (config.url.startsWith(RSS_PATH)) {
      key = RSS_KEY;
    } else if (config.url.startsWith(RIC_AUTH_PATH)) {
      key = RIC_AUTH_KEY;
    }

    if (key) {
      config.headers["Validation-key"] = `Api-key ${key}`;
    }

    // try {
    //   const userGroupId = window.LocalStorage.getItem("USER_GROUP_ID");

    //   if (userGroupId) {
    //     config.headers["Group-ID"] = userGroupId;
    //   }
    // } catch (_) {
    //   // Do nothing
    // }

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// RESPONSE Interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { request, response } = error;

    const EXCEPTION_ROUTES = [
      "/api/token/",
      "/api/email_reset/verification_uuid/",
      "/api/initial_info/registration/",
      "/api/upload-s3-url/",
      "/api/shopping_cart_point_summary/",
      "/api/fail_csv_upload_reports/"
    ];

    const DYNAMIC_EXCEPTION_ROUTES = [
      {
        method: "patch",
        url: new RegExp("/api/shopping_cart_item/\\d+")
      }
    ];

    // Server - Service or Maintenance errors
    if (
      response &&
      response.status &&
      response.status === 503 &&
      response.data
    ) {
      const { type, title, message } = response.data;
      if (type) {
        if (type === "maintenance") {
          LocalStorage.setItem("MAINTENANCE_TITLE", title);
          LocalStorage.setItem("MAINTENANCE_MESSAGE", message);

          window.location.href = "/system-maintenance/";
          return Promise.reject(error);
        } else if (type === "service") {
          LocalStorage.setItem("SERVICE_TITLE", title);
          LocalStorage.setItem("SERVICE_MESSAGE", message);

          window.location.href = "/system-service/";
          return Promise.reject(error);
        }
      }
    }

    const responseURL = request.responseURL;

    const apiURLStartIndex = responseURL.indexOf("/api/");
    const apiURLEndIndex =
      responseURL.indexOf("?", apiURLStartIndex) >= 0
        ? responseURL.indexOf("?", apiURLStartIndex)
        : responseURL.length;

    const apiURL = responseURL.substr(
      apiURLStartIndex,
      apiURLEndIndex - apiURLStartIndex
    );

    if (EXCEPTION_ROUTES.includes(apiURL)) {
      return Promise.reject(error);
    }

    for (let i = 0; i < DYNAMIC_EXCEPTION_ROUTES.length; i++) {
      if (
        DYNAMIC_EXCEPTION_ROUTES[i].url.test(apiURL) &&
        DYNAMIC_EXCEPTION_ROUTES[i].method === response.config.method
      ) {
        return Promise.reject(error);
      }
    }

    const errorStatuses = [
      400,
      401,
      402,
      403,
      404,
      500,
      501,
      502,
      503,
      504,
      505
    ];

    if (
      response &&
      response.status &&
      errorStatuses.includes(response.status)
    ) {
      LocalStorage.setItem(
        "SYSTEM_ERROR",
        responseURL + ":" + response.status
      );

      LocalStorage.setItem("SYSTEM_ERROR_STATUS", response.status);

      LocalStorage.setItem(
        "SYSTEM_ERROR_MESSAGE",
        JSON.stringify(response.data)
      );
      if (response.status === 401 && loginInfo.isSso) {
        // SSOログイン時はログアウトして行き止まり画面へ遷移する
        window.location.href = "/session-time-out/";
      } else if (response.status === 401) {
        LocalStorage.setItem("ON_LOGIN_REDIRECT", window.location.href);
        window.location.href = commons.LOGIN_URL;
      } else {
        window.location.href = "/system-error/";
      }
    }

    return Promise.reject(error);
  }
);
